<template>
  <div class="vld-parent">
    <loading :active.sync="isLoading" 
    :can-cancel="true" 
    :on-cancel="onCancel"
    :is-full-page="fullPage"></loading>
      

    <h1>Bestellungen</h1>
    <div class="card">
      <div class="card-body">
        <BaseFilteringComponent></BaseFilteringComponent>
        
        <div class="form-group row">
          <div class="col-sm-1 col-form-label">Suche</div>
          <div class="col-md-2">
            <input type="text" v-model="filterOrderSQ" class="form-control form-control-sm" placeholder="SKU, BestellNr">  
          </div>

          <div class="col-sm-1 col-form-label" v-if="currentUser.master == 1">Anzeige</div>
          <div class="col-sm-2" v-if="currentUser.master == 1">
            <select class="form-control form-control-sm" v-model="filterOrderType">
                <option value="0">Alle</option>
                <option value="1">Abgeschlossene Bestellungen</option>
                <option value="2">Rücksendungen</option>
            </select>
          </div>

          <div class="col-sm-1 col-form-label" v-if="currentUser.master == 1">Bestellstatus</div>
          <div class="col-sm-2" v-if="currentUser.master == 1">
            <select class="form-control form-control-sm" v-model="filterOrderState">
                <option value="0">Alle</option>
                <option value="7">Ausgeliefert</option>
                <option value="4">Storniert</option>
            </select>
          </div>

        </div>

        <div class="row">
          <div class="col-sm-12">
            <table class="table table-bordered table-striped table-small">
              <tr>
                  <td><strong>Bestellungen</strong></td><td>{{num_orders}}</td>
                  <td><strong>Verkaufte Artikel</strong></td><td>{{num_sold_articles}}</td>
                  <td><strong>Gebühr</strong></td><td>{{totalMargin}} €</td>
                  <td><strong>Verkauf Netto</strong></td><td>{{sum_netto}} €</td>
                  <td><strong>Zahlungsgebühr</strong></td><td>{{total_payment_fee}} €</td>
                  <td><strong>Summe Einkaufspreis</strong></td><td>{{total_purchase_price}} €</td>
              </tr>
            </table>
          </div>
          
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="float-right">
              <button v-on:click="refreshData" class="btn btn-primary btn-sm">
                <font-awesome-icon icon="sync" />
                Refresh
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a @click="downloadCSV" class="btn btn-primary btn-sm" style="margin-top: 10px; margin-bottom: 10px">
      <font-awesome-icon icon="download" />
      CSV Download
    </a>

    <b-pagination
      v-model="currentPage"
      :total-rows="totalCount"
      :per-page="entriesPerPage"
      :limit= 20
    ></b-pagination>

    <table class="table table-striped table-bordered table-hover table-small">
      <thead>
        <tr>
          <th></th>
          <th>Quelle</th>
          <th>DokDatum</th>
          <th>Typ</th>
          <th>BestellNr</th>
          <th>Bestellstatus</th>
          <th>Zahlungsstatus</th>
          <th>KundenNr</th>
          <th>Kunde</th>
          <th>Produkt</th>
          <th>EAN</th>
          <th>SKU</th>
          <th>Menge</th>
          <th>Mwst</th>
          <th>Netto</th>
          <th>Brutto</th>
          <th>Z-Gebühr</th>
          <th>Sum Netto</th>
          <th>Sum Brutto</th>
          <th>Marge %</th>
          <th>Marge €</th>
          <th>EK €</th>
          <th>EK Summe €</th>
        </tr>
      </thead>
      <tbody>
        <OrderRow v-for="(order_entry,index) in orders" :order_entry="order_entry" :key="`order_entry.order_id-${index}`"></OrderRow>
      </tbody>
    </table>
  </div>
</template>

<script>
import OrderRow from '@/components/OrderRow' // eslint-disable-line no-unused-vars
import BaseFilteringComponent from '@/components/BaseFilteringComponent'
import Loading from 'vue-loading-overlay';
import Paginate from 'vuejs-paginate';
import FileSaver from 'file-saver';
import 'vue-loading-overlay/dist/vue-loading.css';

const request = require('superagent')

export default {
  name: 'Orders',
  data () {
    // default is the current month
    var date = new Date()
    var firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)

    firstDay = require('moment')(firstDay).format('YYYY-MM-DD')
    lastDay = require('moment')(lastDay).format('YYYY-MM-DD')

    return {
      orders: [],
      api_token: null,
      num_orders: 0,
      margin_percentage: 0,
      num_order: 0,
      num_sold_articles: 0,
      totalPaymentFees: 0,
      isLoading: false,
      fullPage: true,
      sum_netto: 0,
      total_payment_fee: 0,
      total_purchase_price: 0,
      currentPage: 1,
      totalPages: 1,
      totalCount: 0,
      entriesPerPage: 0,
      totalMargin: 0,
      filterOrderSQ: "",
      filterOrderType: 0,
      filterOrderState: 0
    }
  },
  props: ['api_key'],
  components: {
    'OrderRow': OrderRow,
    Loading,
    'BaseFilteringComponent': BaseFilteringComponent,
    'paginate': Paginate
  },
  mounted: function () {
    this.fetch()
  },
  computed: {
    shopListing: function(){
      return this.$store.state.shops;
    },
    filterShopId(){
        return this.$store.state.filter_shop_id;
    },
    filterFromDate(){
        return this.$store.state.filter_from_date;
    },
    filterToDate(){
        return this.$store.state.filter_to_date;
    },
    currentUser: function(){
      return this.$store.state.current_user
    },
    downloadUrl: function(){
      var url = this.baseUrl+"&format=csv";
      return url;
    },
    baseUrl(){
      var url = process.env.API_HOST + '/api/orders/finished?filter_from_date=' + this.filterFromDate + '&filter_to_date=' + this.filterToDate;
      if(this.currentUser.master == 1 && this.filterShopId != null && parseInt(this.filterShopId) != 0){
        url = url + "&filter_shop_ids="+ this.filterShopId;
      }
      url = url + "&filter_sq=" + this.filterOrderSQ
      url = url + "&filter_order_type=" + this.filterOrderType
      url = url + "&filter_order_state=" + this.filterOrderState

      return url;
    }
  },
  watch: {
    currentPage(new_val,old_val){
      this.currentPage = new_val;
      this.fetch();
    }
  },
  methods: {
    downloadCSV(){
      var that = this
      request
        .get(this.downloadUrl)
        .set('Authorization',this.api_token)
        .then(function (res) {
          var blob = new Blob(["\uFEFF" + res.text], {type: "text/comma-separated-values;charset=utf-8"});

          FileSaver.saveAs(blob, "fakturierte_bestellungen.csv",{ autoBom: true} );
        })

    },
    fetch: function () {
      this.api_token = localStorage.getItem('API_TOKEN')

      var url = this.baseUrl+'&page='+this.currentPage;
      

      this.isLoading = true
      var that = this
      request
        .get(url)
        .set('Accept', 'application/json')
        .set('Authorization',this.api_token)
        .then(function (res) {
          that.orders = res.body.orders
          that.from_date = res.body.from_date
          that.to_date = res.body.end_date
          that.num_orders = res.body.total_orders
          that.margin_percentage = res.body.margin_percentage
          that.num_sold_articles = res.body.total_ordered_articles;
          that.total_payment_fee = res.body.total_payment_fee;
          that.sum_netto = res.body.total_netto;
          that.total_purchase_price = res.body.total_purchase_price;
          that.currentPage = res.body.current_page
          that.totalPages = res.body.total_pages
          that.totalCount = res.body.total_count
          that.entriesPerPage = res.body.per_page
          that.totalMargin = res.body.total_rt_margin
          that.isLoading = false;
        })
        
    },
    refreshData: function () {
      this.fetch()
    },
    onCancel:function() {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders.vue